import { BAILocale } from '.';
import it_IT from 'antd/es/locale/it_IT';

const localeValue: BAILocale = {
  lang: 'it',
  antdLocale: it_IT,
};

export default localeValue;
